export const QUOTE_RATE_PROFILES = {
    design: { id: "design", label: "Engineering / scope & design", hourlyRate: 135 },
    rd: { id: "rd", label: "R&D / feasibility", hourlyRate: 150 },
    installation: { id: "installation", label: "Commissioning / onsite labor", hourlyRate: 150 },
    software: { id: "software", label: "Custom software", hourlyRate: 200 },
    training: { id: "training", label: "Training / documentation", hourlyRate: 105 },
    pm: { id: "pm", label: "Project management", hourlyRate: 105 },
    travel: { id: "travel", label: "Travel time", hourlyRate: 95 },
};

export const LABOR_CATEGORIES = Object.values(QUOTE_RATE_PROFILES);

const GROUP_KEY_TO_PROFILE = {
    electrical_enclosure: "design",
    "electrical-enclosure": "design",
    robot_cell: "design",
    "robot-cell": "design",
    eoat: "design",
    existing_machine: "design",
    "existing-machine": "design",
    machine_tending: "design",
    "machine-tending": "design",
    basic: "design",
    advanced: "design",
    palletizing: "design",
    packaging: "design",
    inspection: "design",
    safety: "design",
    software: "software",
    training: "training",
    training_docs: "training",
    project_management: "pm",
    pm: "pm",
    travel_time: "travel",
    travel: "travel",
    "rd-time": "rd",
    installation: "installation",
    robot: "design",
    freight: "travel",
};

const LABEL_HINTS = [
    [/project\s*manag|coordinat|pm\b/i, "pm"],
    [/r\s*&\s*d|research|feasib/i, "rd"],
    [/install|commission/i, "installation"],
    [/software|program|erp/i, "software"],
    [/train|handover/i, "training"],
    [/enclos|electrical/i, "design"],
];

export function rateProfileForCategory(categoryId) {
    const id = String(categoryId || "").trim();
    return QUOTE_RATE_PROFILES[id] || null;
}

export function rateProfileForGroup({ groupKey, groupLabel } = {}) {
    const key = String(groupKey || "").trim();
    if (GROUP_KEY_TO_PROFILE[key]) return QUOTE_RATE_PROFILES[GROUP_KEY_TO_PROFILE[key]];
    const label = String(groupLabel || "");
    for (const [re, id] of LABEL_HINTS) {
        if (re.test(label)) return QUOTE_RATE_PROFILES[id];
    }
    return QUOTE_RATE_PROFILES.design;
}

export function rateProfileForItem(item = {}) {
    return (
        rateProfileForCategory(item.laborCategory) ||
        rateProfileForGroup({
            groupKey: item.groupKey,
            groupLabel: item.groupLabel || item.title,
        })
    );
}

export function laborCostFromHours(hours, profile) {
    const h = Number(hours);
    if (!Number.isFinite(h) || h <= 0) return null;
    const rate = Number(profile?.hourlyRate) || 0;
    return rate > 0 ? h * rate : null;
}
